__turbopack_context__.v({
  "account": "journeyFunding-module-scss-module__hzDADW__account",
  "calendarStage": "journeyFunding-module-scss-module__hzDADW__calendarStage",
  "day": "journeyFunding-module-scss-module__hzDADW__day",
  "dayCheck": "journeyFunding-module-scss-module__hzDADW__dayCheck",
  "notification": "journeyFunding-module-scss-module__hzDADW__notification",
  "phoneStage": "journeyFunding-module-scss-module__hzDADW__phoneStage",
  "rings": "journeyFunding-module-scss-module__hzDADW__rings",
});
